import * as React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { graphql } from "react-apollo";
import { gql } from "apollo-boost";
import { contactDisplayName } from "../../../utils/helpers";
import * as colors from "../../../settings/colors";
import Moment from "react-moment";

import Loader from "../../PulseLoader";
import { Table, TableRow, TableCell } from "../../Table";
import EmptyMessage from "../../EmptyMessage";
import ServiceProductionStatus from "../../ServiceProductionStatus";

const STATUS_ORDER = ["open", "on_hold"];

const StyledLink = styled(Link)`
  color: ${colors.TEXT};
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: ${colors.BLUE};
  }
`;

class SalesDrawingQueue extends React.Component {
  componentDidMount() {
    if (this.props.data) {
      this.props.data.refetch();
    }
  }

  renderService = service => {
    const { job } = service;
    const { contact, franchise } = job;
    const contactName = contactDisplayName(contact);

    return (
      <TableRow key={service.id} onHold={service.status === "on_hold"}>
        <TableCell>
          <StyledLink to={`/admin/jobs/${job.id}/services/${service.id}`}>
            {contactName}
          </StyledLink>
        </TableCell>
        <TableCell>{service.options.drawingDepth || "Unspecified"}</TableCell>
        <TableCell>
          <Moment format="MMM D, YYYY [at] h:mm a">
            {service.submittedAt}
          </Moment>
        </TableCell>
        <TableCell>{franchise && franchise.name}</TableCell>
        <TableCell>
          <ServiceProductionStatus service={service} />
        </TableCell>
      </TableRow>
    );
  };

  render() {
    if (this.props.data) {
      const { loading, services } = this.props.data;

      if (loading) {
        return <Loader />;
      }

      if (!services || !services.length) {
        return (
          <EmptyMessage>
            It looks like the production queue is empty!
          </EmptyMessage>
        );
      }

      const sortedServices = services.slice().sort((a, b) => {
        const byStatus =
          STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status);

        if (byStatus === 0) {
          return new Date(a.submittedAt) - new Date(b.submittedAt);
        }

        return byStatus;
      });

      return (
        <Table>
          <TableRow header>
            <TableCell>Name</TableCell>
            <TableCell>Option</TableCell>
            <TableCell>Submitted At</TableCell>
            <TableCell>Franchise</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
          {sortedServices.map(this.renderService)}
        </Table>
      );
    }

    return null;
  }
}

const SalesDrawingQueueQuery = gql`
  query SalesDrawingQueueQuery {
    services(queue: "sales_drawing") {
      id
      serviceType
      submittedAt
      status
      options {
        drawingDepth
        pdfDrawings
      }
      productionSteps {
        id
        stepType
        startedAt
        completedAt
        user {
          id
          name
        }
      }
      job {
        id
        contractNumber
        contact {
          id
          firstName
          lastName
          otherFirstName
          otherLastName
        }
        franchise {
          id
          name
        }
      }
    }
  }
`;

export default graphql(SalesDrawingQueueQuery, {
  options: { pollInterval: 1000 * 30 }
})(SalesDrawingQueue);



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard/SalesDrawingQueue.js